import {Spin} from "antd";
import {useObserver} from "mobx-react-lite";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {
    Container,
    CustomerContainer,
    FormContainer,
    CustomerFormContainer,
    MapContainer,
    CustomerMapContainer
} from "./CreateDeliveryRequest.styles";
import {DeliveryRequestMap} from "./deliveryRequestMap/DeliveryRequestMap";
import {useCreateDeliveryRequest} from "./useCreateDeliveryRequest";
import {DeliveryRequestForm} from "./deliveryRequestForm/DeliveryRequestForm";
import CustomerApproveDeliveryModal from "../customer/customerManualDeliveryPage/customerApproveDeliveryModal/CustomerApproveDeliveryModal";
import CustomerCreditWarningModal from "../customer/customerManualDeliveryPage/customerCreditWarningModal/CustomerCreditWarningModal";

export const CreateDeliveryContext = React.createContext();
export const CreateDeliveryRequest = ({isFromCustomerTheme = false}) => {
    const [orderLoading, setOrderLoading] = useState(false);
    const deliveryRequestContext = useCreateDeliveryRequest({isFromCustomerTheme});
    const {t} = useTranslation(["newRequest"]);

    // Choose styles based on customer theme
    const ContainerComponent = isFromCustomerTheme ? CustomerContainer : Container;
    const FormContainerComponent = isFromCustomerTheme ? CustomerFormContainer : FormContainer;
    const MapContainerComponent = isFromCustomerTheme ? CustomerMapContainer : MapContainer;

    return useObserver(() => (
        <Spin
            spinning={orderLoading}
            style={{
                marginTop: isFromCustomerTheme ? 10 : 60,
                width: "100%"
            }}
            tip={t("newRequest.orderDataLoading", {
                ns: "newRequest"
            })}
            size="large"
        >
            <CreateDeliveryContext.Provider
                value={{...deliveryRequestContext, isFromCustomerTheme}}
            >
                <ContainerComponent data-testid="createDeliveryRequest">
                    <FormContainerComponent
                        xs={{span: 24, order: 2}}
                        lg={{span: 12, order: 1}}
                        xl={{span: 12, order: 1}}
                    >
                        <DeliveryRequestForm />
                    </FormContainerComponent>
                    <MapContainerComponent
                        xs={{span: 24, order: 1}}
                        lg={{span: 12, order: 2}}
                        xl={{span: 12, order: 2}}
                    >
                        <DeliveryRequestMap subCompanies={[]} />
                    </MapContainerComponent>
                </ContainerComponent>
                {deliveryRequestContext.showCustomerModal && deliveryRequestContext.modalData && (
                    <CustomerApproveDeliveryModal
                        orderDetails={deliveryRequestContext.modalData.orderDetails}
                        totalOrdersPrice={deliveryRequestContext.modalData.totalOrdersPrice}
                        payload={deliveryRequestContext.modalData.payload}
                        fromCustomerTheme={
                            deliveryRequestContext.modalData.fromCustomerTheme ??
                            isFromCustomerTheme
                        }
                        history={deliveryRequestContext.modalData.history}
                        visible={deliveryRequestContext.showCustomerModal}
                        onCancel={() => deliveryRequestContext.setShowCustomerModal(false)}
                        setShowCreditWarningModal={deliveryRequestContext.setShowCreditWarningModal}
                        setCreditWarningMessage={deliveryRequestContext.setCreditWarningMessage}
                        onApprove={deliveryRequestContext.modalData.onApprove}
                    />
                )}
                {deliveryRequestContext.showCreditWarningModal && (
                    <CustomerCreditWarningModal
                        content={deliveryRequestContext.creditWarningMessage}
                        visible={deliveryRequestContext.showCreditWarningModal}
                        onCancel={() => deliveryRequestContext.setShowCreditWarningModal(false)}
                    />
                )}
            </CreateDeliveryContext.Provider>
        </Spin>
    ));
};
